import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const DoubleChinTreating = lazyWithPreload(
  () => import('./DoubleChinTreating'),
)
